<div (keypress)="readBarcode($event)">

  <div class="grid grid-cols-12 gap-4">

    @if(cargoFeatures?.isScaleEnabled){
    <div class="col-span-12 md:col-span-6 lg:col-span-3 pl-8 pr-8">
      <div class="flex flex-col">
        <h5>Вес посылки (гр):</h5>

        <p-inputGroup [ngStyle]="{'max-width': '350px'}">
          <p-inputGroupAddon [ngStyle]="{padding: 0}">
            <p-button (click)="connectToScale()" [text]="true" pTooltip="Подключиться к весам">Connect</p-button>
          </p-inputGroupAddon>
          <input pInputText [(ngModel)]="weightValue">
          <p-inputGroupAddon>гр.</p-inputGroupAddon>
        </p-inputGroup>

        <small class="text-left">
          Статус весов:
          <p class="uppercase inline" [ngClass]="{'wConnected': connected, 'wDisconnected': !connected}">
            @if(connected) {подключены} @else {не подключены}
          </p>
        </small>
      </div>
    </div>
    }

    <div class="col-span-12 md:col-span-6 lg:col-span-3 pl-8 pr-8">
      <div class="flex flex-col">
        <label class="lbl">Трек-номер:</label>
        @if(cargoFeatures?.isManualInput) {
        <p-inputGroup [ngStyle]="{'max-width': '350px'}">
          <input pInputText type="text" [(ngModel)]="scanValue" (keyup)="onKeyUp($event)" autofocus>
          <p-inputGroupAddon [ngStyle]="{padding: 0}">
            <p-button icon="pi pi-save" [text]="true" (click)="saveScannedValue()" severity="success"
              pTooltip="Сохранить"></p-button>
          </p-inputGroupAddon>
        </p-inputGroup>
        } @else {
        <p-inputGroup [ngStyle]="{'max-width': '350px'}">
          <input pInputText type="text" [value]="scanValue" autofocus readonly>
          <p-inputGroupAddon [ngStyle]="{padding: 0}">
            <p-button icon="pi pi-trash" [text]="true" (click)="clearValue()"
             severity="warn"
              pTooltip="Очистить поле"></p-button>
          </p-inputGroupAddon>
        </p-inputGroup>
        }
      </div>
    </div>


    @if(cargoFeatures?.isBulkReceiveEnabled) {
    <div class="col-span-12 md:col-span-6 lg:col-span-3 pr-8 pl-8">
      <label class="lbl">Дата треков:</label>
      <div class="flex flex-col">
        <div class="nobr">
          <p-datepicker [(ngModel)]="packageDate" name="packageDate" dateFormat="dd.mm.yy" [showTime]="true"
            [showIcon]="true" [iconDisplay]="'input'">
          </p-datepicker>
          <p-button (click)="showImportPackagesDlg()" icon="pi pi-sort-amount-down" severity="danger"
            pTooltip="Загрузить спискок треков">
          </p-button>
        </div>
        <small>Загрузка списка треков</small>
      </div>
    </div>
    }

  </div>


  <div class="p-6">
    <p-table [value]="tracknumbers" [tableStyle]="{ 'min-width': '40rem' }">
      <ng-template #header>
        <tr>
          <th>#</th>
          <th class="nobr">Трек-номер</th>
          <th class="nobr">Время сканирования</th>
          <th>Клиент</th>
          <th>Статус</th>
        </tr>
      </ng-template>
      <ng-template #body let-track>
        <tr>
          <td>{{ track.rownum }}</td>
          <td>{{ track.tracknum }}</td>
          <td>{{ track.time | date: 'dd.MM.yyyy HH:mm:ss' }}</td>
          <td>
            @if(track.userInfo && track.userInfo.client_code) {
            <b>{{track.userInfo.client_code}} @if(track.userInfo.client_city) { ({{track.userInfo.client_city}})}</b>
            } @else {
            <нет данных>
            }
          </td>
          <td>
            @let vStyle = {
            'waiting': (track.state === packageState.waiting),
            'processing': (track.state === packageState.processing),
            'received': (track.state === packageState.processed),
            'alreadyReceived':(track.state === packageState.already_processed),
            'error': (track.state !== packageState.waiting && track.state !== packageState.processed && track.state !==
            packageState.already_processed)
            };
          
            <div class="nobr text-bold text-white pl-3" [ngClass]="vStyle">
              @switch(track.state) {
              @case(packageState.waiting) {Ожидает}
              @case(packageState.processing) {Обрабатывается}
              @case(packageState.processed) {Обработан}
              @case (packageState.already_processed) {Уже обработан}
              @default {Неизвестная ошибка}
              }
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <p-dialog header="Загрузка списка треков" [(visible)]="showDialog" [modal]="true" [maximizable]="true"
    (onHide)="cancelImport()">


    <div class="p-fluid">
      <div class="field">
        <label for="tracksData">Трек-номера:</label>
        <textarea id="tracksData" pInputText [(ngModel)]="tracksData" rows="10"></textarea>
      </div>
    </div>

    <p-footer>
      <p-button (click)="bulkImport()">Загрузить</p-button>
      <p-button severity="warn" (click)="cancelImport()">Отмена</p-button>
    </p-footer>
  </p-dialog>

</div>